import { types } from 'mobx-state-tree';
import { InfoColumnScreen } from '../types';

export const UIStates = types
  .model('HouseChats UIStates', {
    isInfoColumnOpen: types.optional(types.boolean, true),
    activeChatAtBottom: types.optional(types.boolean, true),
    infoColumnScreen: types.optional(
      types.enumeration<InfoColumnScreen>('InfoColumnScreen', [
        'main',
        'stats',
        'houses',
      ]),
      'main'
    ),
  })
  .actions((self) => ({
    toggleInfoColumn() {
      self.isInfoColumnOpen = !self.isInfoColumnOpen;
    },
    setActiveChatAtBottom(atBottom: boolean) {
      self.activeChatAtBottom = atBottom;
    },
    setInfoColumnScreen(screen: InfoColumnScreen) {
      self.infoColumnScreen = screen;
    },
    revealInfoColumnScreen(screen: InfoColumnScreen) {
      self.infoColumnScreen = screen;
      self.isInfoColumnOpen = true;
    },
  }));
